import Helper from '@ember/component/helper';
import { getOwner } from '@ember/owner';
import { tracked } from '@glimmer/tracking';
import type FeatureFlagsService from 'walden-fast/services/feature-flags';
import type { FeatureFlag } from 'walden-fast/services/feature-flags';

interface FeatureEnabledSignature {
  Args: {
    Positional: [FeatureFlag];
  };
  Return: boolean;
}

export default class FeatureEnabledHelper extends Helper<FeatureEnabledSignature> {
  @tracked flags: Partial<Record<FeatureFlag, boolean>> = {};

  compute([flag]: [FeatureFlag]) {
    const flagService = getOwner(this)?.lookup(
      'service:feature-flags',
    ) as FeatureFlagsService;

    if (Object.keys(this.flags).includes(flag)) {
      return this.flags[flag] as boolean;
    }

    flagService
      .isEnabled(flag)
      .then((isEnabled) => {
        this.flags = { ...this.flags, [`${flag}`]: isEnabled };
      })
      .catch((e) => {
        console.error(e);
      });
    return false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'feature-enabled': typeof FeatureEnabledHelper;
  }
}
